"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModule = void 0;
const Module_1 = require("../Module");
const sessionStorageVariantName = "linksandbuttons_currentVariant";
function getVariant(configBag, variant) {
    if (!configBag) {
        throw new Error("configBag is required");
    }
    if (variant && configBag[variant]) {
        sessionStorage.setItem(sessionStorageVariantName, variant);
        return configBag[variant];
    }
    let configVariantIds = Object.keys(configBag);
    if (configVariantIds.length === 0) {
        throw new Error("configBag is required");
    }
    else if (configVariantIds.length === 1) {
        sessionStorage.setItem(sessionStorageVariantName, configVariantIds[0]);
        return configBag[configVariantIds[0]];
    }
    let currentExperimentName = sessionStorage.getItem(sessionStorageVariantName);
    if (!currentExperimentName || !configBag[currentExperimentName]) {
        currentExperimentName = configVariantIds[getRandomNumber(configVariantIds.length)];
        sessionStorage.setItem(sessionStorageVariantName, currentExperimentName);
    }
    return configBag[currentExperimentName];
}
function getModule(configBag, variant) {
    const selectedConfig = getVariant(configBag, variant);
    const selectedConfigName = sessionStorage.getItem(sessionStorageVariantName);
    if (selectedConfigName === null) {
        selectedConfig.configVariantId = undefined;
    }
    else {
        selectedConfig.configVariantId = selectedConfigName;
    }
    return new Module_1.Module(selectedConfig);
}
exports.getModule = getModule;
function getRandomNumber(max) {
    return Math.floor(Math.random() * max);
}
